import Box from '@mui/material/Box';
import theme from '../theme';

function VideoMockup({
  background,
  phoneBg,
  frame,
  video,
  videoStyle = {},
  phoneBgStyle = {},
  frameStyle = {},
  aspectRatio = '16/9'
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio,
        borderRadius: '16px',
        overflow: 'hidden',
        my: 4,
        backgroundColor: theme.colors.backgroundCard
      }}
    >
      {/* Video positioned inside the phone frame */}
      {video && (
        <video
          src={video}
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 3,
            objectFit: 'cover',
            borderRadius: '24px !important',
            height: '78%',
            width: 'auto',
            ...videoStyle
          }}
        />
      )}

      {/* Background image */}
      {background && (
        <img
          src={background}
          alt=""
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 1
          }}
        />
      )}

      {/* Phone background (behind video) */}
      {phoneBg && (
        <img
          src={phoneBg}
          alt=""
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            height: '90%',
            width: 'auto',
            zIndex: 3,
            pointerEvents: 'none',
            ...phoneBgStyle
          }}
        />
      )}
    </Box>
  );
}

export default VideoMockup;
